import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import TsdiInvoiceGroup from 'src/components/project-billing/models/InvoiceGroup';
import InvoiceGroupSubcode from 'src/models/AP/InvoiceGroupSubcode';
import Fieldset from '../components/FieldSetComponent';

interface IEditInvoiceGroupNameDialogProps {
    dialogName: string;
    handleConfirm?: (groupDefinition: TsdiInvoiceGroup) => void;
    hideDialog: () => void;
    label?: string;
    invoiceGroup?: TsdiInvoiceGroup;
    create?: Array<InvoiceGroupSubcode>;
    projectId?: number;
}

const EditInvoiceGroupNameDialog = (props: IEditInvoiceGroupNameDialogProps) => {
    const [invoiceGroup, setInvoiceGroup] = useState<TsdiInvoiceGroup>(undefined);
    const [igSections, setIgSections] = useState<Array<InvoiceGroupSubcode>>(undefined);
    const [descriptionChhanged, setDescriptionChhanged] = useState<boolean>(false);
    const [clientAccountCode, setClientAccountCode] = useState<string>(undefined);
    const { register, reset, getValues, setValue } = useForm();
    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (
            props?.invoiceGroup &&
            'groupNumber' in props.invoiceGroup &&
            'groupAccountCode' in props.invoiceGroup
          ) {
            setInvoiceGroup(props?.invoiceGroup);
        }
    }, [props?.invoiceGroup]);

    useEffect(() => {
        if (props?.create) {
            setIgSections(props?.create);
        }
    }, [props?.create]);

    useEffect(() => {
        if (Array.isArray(igSections)) {
            setClientAccountCode(getClientAccountCode());
        }
    }, [igSections]);

    useEffect(() => {
        if (
            props?.invoiceGroup &&
            'groupNumber' in props.invoiceGroup &&
            'groupAccountCode' in props.invoiceGroup
          ) {
            setValue('groupNumber', invoiceGroup.groupNumber.toString());
        }
    }, [invoiceGroup]);

    const onCreate = () => {
        reset({ groupNumber: '0' });
    };

    const getClientAccountCode = () => {
        let accountCode = '';
        if (props?.create && invoiceGroup) {
            props.create.forEach((sc) => {
                accountCode += invoiceGroup.clientNumber + '.' +
                invoiceGroup.projectNumber + '.' + sc.sectionNumber + ', ';
            });
        }
        return accountCode.replace(/[,\s]+$/, '');
    };

    const getGroupDescription = () => {
        let accountCode = '';
        if (props?.create) {
            props.create.forEach((sc) => {
                accountCode += sc.clientAccountCode + ' ';
            });
        }
        return accountCode.trimRight();
    };

    const OKClicked = () => {
        const formValues = getValues();
        const newInvoiceGroup = new TsdiInvoiceGroup();
        newInvoiceGroup.description = formValues.description;
        newInvoiceGroup.accountCode = formValues.accountCode;
        newInvoiceGroup.projectId = props.projectId ?? invoiceGroup?.projectId;
        newInvoiceGroup.frequency = formValues.frequency;
        newInvoiceGroup.prospectInvoiceGroup = Number(formValues.prospectInvoiceGroup);
        props.handleConfirm(!props?.create ? formValues as TsdiInvoiceGroup : newInvoiceGroup);
        props.hideDialog();
    };

    return (
        <Dialog
            title={props?.create ? 'Create Invoice Group' : 'View/Edit Invoice Group'}
            dialogName={props.dialogName}
            isExitButtonInvisible={true}
            bodyStyle={{ width: '15%' }}
        >
            <div style={{  width: '100%', display: 'flex', justifyContent: 'left' }}>
                <form
                    style={{ width: '100%'}}
                >
                    {props?.create && <div
                        style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}
                    >
                        <label>{'Prospect invoice Group'}</label>
                        <label
                            style={{marginLeft: '1rem', fontWeight: 'bold'}}
                        >
                            {props?.invoiceGroup?.prospectInvoiceGroup ? props?.invoiceGroup?.prospectInvoiceGroup.toString() : ''}
                        </label>
                    </div>}
{/*                     {props?.create && <RHFInputBox
                        register={register}
                        name={'prospectInvoiceGroup'}
                        label={'Prospect invoice Group'}
                        labelOnLeft={true}
                        defaultVal={props?.invoiceGroup?.prospectInvoiceGroup ? props?.invoiceGroup?.prospectInvoiceGroup.toString() : ''}
                    />} */}
                    {!props?.create && <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', whiteSpace: 'nowrap'}}>
                        <label style={{whiteSpace: 'nowrap'}}>
                            Group #:
                        </label>
                        <label style={{marginLeft: '1rem', fontWeight: 'bold'}}>
                            {invoiceGroup?.groupNumber}
                        </label>
                    </div>}
                    {!props?.create && <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', whiteSpace: 'nowrap'}}>
                        <label style={{whiteSpace: 'nowrap'}}>
                            Created By:
                        </label>
                        <label style={{marginLeft: '1rem', fontWeight: 'bold'}}>
                            {invoiceGroup?.createdByName}({invoiceGroup?.createdBy})
                        </label>
                        <label style={{marginLeft: '1rem', whiteSpace: 'nowrap'}}>
                            Created On:
                        </label>
                        <label style={{marginLeft: '1rem', fontWeight: 'bold'}}>
                            {new Date(invoiceGroup?.creationDate).toLocaleDateString()}
                        </label>
                    </div>}
                    {!props?.create && <br />}
                    <label>{`Client Account Code`}</label>
                    <RHFTextArea
                        register={register}
                        name={'accountCode'}
                        defaultValue={!props?.create ? invoiceGroup?.accountCode : clientAccountCode}
                        style={{width: '100%', height: '4.5em', overflow: 'hidden', resize: 'none'}}
                        onChange={() => { setValue('clientAccountCode', invoiceGroup?.groupAccountCode); }}
                    />
                    <br />
                    <label>{`Group Name / Description`}</label>
                    <RHFTextArea                    
                        register={register}
                        defaultValue={props?.create ? getGroupDescription() : invoiceGroup?.description}
                        name={'description'}
                        style={{width: '100%', height: '10rem', resize: 'none'}}
                        onChange={() => setDescriptionChhanged(true)}
                    />
                    {props?.create && <RHFInputBox
                        register={register}
                        name={'invoiceDate'}
                        type={'date'}
                        defaultVal={new Date().toISOString().split('T')[0]}
                        label={'Invoice Group Date'}
                        labelOnLeft={true}
                        style={{ width: '100%', whiteSpace: 'nowrap' }}
                        bodyStyle={{marginLeft: '2re,', width: '50%', whiteSpace: 'nowrap' }}
                    />}
                    {props?.create && <Fieldset
                        label={'Billing'}
                    >
                        <RHFSelect
                            label={'Frequency:'}
                            defaultVal={1}
                            name={'frequency'}
                            labelStyle={{whiteSpace: 'nowrap'}}
                            labelOnLeft={true}
                            style={{marginLeft: '5.6rem', width: '100%', whiteSpace: 'nowrap' }}
                            bodyStyle={{ width: '62%', whiteSpace: 'nowrap' }}
                            options={[
                                { value: 'O', label: 'Once (WIP Standard)' },
                                { value: 'M', label: 'Monthly' },
                                { value: 'B', label: 'Bi-Monthly' },
                                { value: 'Q', label: 'Quarterly' },
                                { value: 'S', label: 'Semi-Annual' },
                                { value: 'A', label: 'Annual' },
                                { value: 'P', label: 'Pay Period' }
                            ]}
                            register={register}
                        />
                        <RHFInputBox
                            register={register}
                            name={'requestDate'}
                            type={'date'}
                            label={'Begin Date:'}
                            labelOnLeft={true}
                            labelStyle={{whiteSpace: 'nowrap'}}
                            style={{marginLeft: '4.2rem', width: '100%', whiteSpace: 'nowrap' }}
                            bodyStyle={{marginLeft: '2re,', width: '50%', whiteSpace: 'nowrap' }}
                        />
                    </Fieldset>}
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={props?.create ? 'Create Group' : (descriptionChhanged ? 'Save' : 'OK')}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default EditInvoiceGroupNameDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/EditInvoiceGroup.tsx